import { render, staticRenderFns } from "./InterpretationAccountManager.vue?vue&type=template&id=04a6fbc8&scoped=true&"
import script from "./InterpretationAccountManager.vue?vue&type=script&lang=js&"
export * from "./InterpretationAccountManager.vue?vue&type=script&lang=js&"
import style0 from "./InterpretationAccountManager.vue?vue&type=style&index=0&id=04a6fbc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6fbc8",
  null
  
)

export default component.exports